import { App, MerchantPlan } from '../models/app';
import { appInstallRequiresAnotherPlan } from '../component-helpers/merchant-plans';
import { useMemo } from 'react';
import { useMerchant } from '../contexts/providers/merchant';

export const useAppInstallRequiresAnotherPlan = (app: App): { requiresAnotherPlan: boolean, unSupportedPlan?: MerchantPlan } => {
  const { merchantData } = useMerchant();
  return useMemo(() => {
    if (!merchantData) return { requiresAnotherPlan: false };

    const { merchantPlan } = merchantData;
    const requiresAnotherPlan = appInstallRequiresAnotherPlan(app, merchantPlan);
    return {
      requiresAnotherPlan,
      unSupportedPlan: requiresAnotherPlan ? merchantPlan : undefined,
    };
  }, [app, merchantData]);
};
